<template>
  <section>
    <b-tabs
      class="lr-tabs"
      v-model="activeTab"
    >
      <b-tab-item
        :label="$t(`Admin.${titleTab}`)"
        icon="account-plus"
      >
        <new-partner />
      </b-tab-item>

      <b-tab-item
        v-if='showDriverTab'
        :label="$t('Admin.tabLabel3')"
        icon="dolly"
      >
        <new-vehicle />
        <list-vehicle />
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import NewPartner from '@/components/miscellaneous/NewPartner'
import NewVehicle from '@/components/miscellaneous/NewVehicle'
import ListVehicle from '@/components/miscellaneous/ListVehicle'
import { services } from '@/services'

export default {
  name: 'Admin',
  data () {
    return {
      activeTab: 0,
      titleTab: '',
      showDriverTab: false
    }
  },
  components: {
    NewPartner,
    NewVehicle,
    ListVehicle
  },
  async mounted () {
    const role = this.$store.getters['user/status'].info.authorities
    const rules = services.userService('', role)
    const showTab = rules.showDriverTab()
    const hasPartner = rules.showDropPartner()
    const titleTab = rules.titleTab()

    if (hasPartner) await this.$store.dispatch('user/getPartners')
    await this.$store.dispatch('user/getProfiles')
    await this.$store.dispatch('user/getStores')

    if (showTab) this.showDriverTab = showTab
    if (titleTab) this.titleTab = titleTab
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Admin.vue